module.exports = __webpack_public_path__ + "img/98.9767db7.png";